import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>IdeaPetal Games</h3>
          <p>Your destination for fun and engaging mini games. Play free online games anytime, anywhere.</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/games">Web Games</Link></li>
            <li><Link to="/mobile-games">Mobile Games</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/mobile-games-terms">Mobile Games Terms</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect</h4>
          <p>Follow us for updates and new game releases!</p>
          <div className="social-links">
            {/* Add social media links here when available */}
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} IdeaPetal Games. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
